export const RECEIVED_COPY = 'RECEIVED_COPY';

const getCustomCopy = () => (
    (dispatch) => {
        let customCopy = window.customCopy;
        if (Array.isArray(customCopy)) {
          customCopy = {};
        }

        dispatch({
            type: RECEIVED_COPY,
            customCopy,
        });
    }
);

export default getCustomCopy;
